"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const between_1 = __importDefault(require("./between"));
const unknown_1 = __importDefault(require("./unknown"));
const months = [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre",
];
exports.default = (monthAsString) => {
    const month = Number(monthAsString);
    if ((0, between_1.default)(1, month, 12)) {
        return {
            name: months[month - 1],
            index: month,
            unknown: undefined,
        };
    }
    if ((0, between_1.default)(30, month, 42) || (0, between_1.default)(50, month, 99) || month === 20) {
        return (0, unknown_1.default)();
    }
    return (0, unknown_1.default)("appears to be incorrect");
};
//# sourceMappingURL=makeMonth.js.map